import React from "react";
import { Container, Row, Col, Card, Button, Table } from "react-bootstrap";

const courses = [
  {
    title: "Foundation Course (8th - 10th)",
    description: "Building a strong base for IIT-JEE with core Mathematics, Physics, and Chemistry concepts.",
    syllabus: [
      "Mathematics: Algebra, Geometry, Trigonometry, Number System",
      "Physics: Basic Mechanics, Electricity, Optics, Thermodynamics",
      "Chemistry: Atomic Structure, Periodic Table, Chemical Bonding",
    ],
    books: ["NCERT Books", "RD Sharma (Maths)", "HC Verma (Physics)", "Concise Chemistry"],
  },
  {
    title: "Professional Course (11th - 12th)",
    description: "Advanced level problem-solving for IIT-JEE preparation, covering in-depth syllabus.",
    syllabus: [
      "Mathematics: Calculus, Coordinate Geometry, Probability, Matrices",
      "Physics: Advanced Mechanics, Electrostatics, Modern Physics",
      "Chemistry: Organic, Inorganic & Physical Chemistry",
    ],
    books: [
      "NCERT Books",
      "Irodov (Physics)",
      "MS Chouhan (Organic Chemistry)",
      "Cengage Series (Mathematics)",
    ],
  },
];

const examDetails = [
  { exam: "JEE Main (Session 1)", date: "January 2025" },
  { exam: "JEE Main (Session 2)", date: "April 2025" },
  { exam: "JEE Advanced", date: "June 2025" },
];

const IITJEETraining = () => {
  return (
    <Container className="py-5">
      <h2 className="text-center mb-4">IIT-JEE Training Program</h2>
      
      <Row>
        {courses.map((course, index) => (
          <Col md={6} className="mb-4" key={index}>
            <Card className="shadow-lg">
              <Card.Body>
                <Card.Title>{course.title}</Card.Title>
                <Card.Text>{course.description}</Card.Text>
                <h6>Syllabus:</h6>
                <ul>
                  {course.syllabus.map((topic, idx) => (
                    <li key={idx}>{topic}</li>
                  ))}
                </ul>
                <h6>Recommended Books:</h6>
                <ul>
                  {course.books.map((book, idx) => (
                    <li key={idx}>{book}</li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <h3 className="mt-5 text-center">Exam Dates & Schedule</h3>
      <Table striped bordered hover responsive className="mt-3">
        <thead>
          <tr>
            <th>Exam</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {examDetails.map((exam, index) => (
            <tr key={index}>
              <td>{exam.exam}</td>
              <td>{exam.date}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="text-center mt-4">
        <Button variant="primary">Enroll Now</Button>
      </div>
    </Container>
  );
};

export default IITJEETraining;
